import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateFallback',
  standalone: true,
})
export class TranslateFallbackPipe implements PipeTransform {
  private _translateService = inject(TranslateService);

  public transform(tranlsationKey: string | undefined, tranlsationFallback = ''): string {
    if (tranlsationKey) {
      const tranlsation = this._translateService.instant(tranlsationKey);
      if (tranlsation === tranlsationKey && tranlsationFallback) {
        return this._translateService.instant(tranlsationFallback);
      }
      return tranlsation;
    }
    return '';
  }
}
